import type { MailboxInfo } from "owa-client-types";
import { isServiceRequestSupportedForMailbox } from "owa-service/lib/utils/isServiceRequestSupportedForMailbox";
import { isOfflinePeopleDataViaPDVEnabled, type PDVStateDetails, } from "./isOfflinePeopleDataViaPDVEnabled";
import { isOfflineSyncEnabled } from "./isOfflineSyncEnabled";
import { getIsDataWorkerFaulted, getIsOfflineDataFaulted } from "owa-config";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

/**
 * Returns true if online sync is enabled for a mailbox that supports service requests.
 * Healthy offline sync takes priority over online sync.
 * With peo-no-hub-fallback, online PDV can also recover from an offline-data fault without
 * changing the user's offline preference. A failed worker cannot run this recovery.
 */
export function isOnlineSyncEnabled(mailboxInfo: MailboxInfo): boolean {
    if (!isServiceRequestSupportedForMailbox(mailboxInfo)) {
        return false;
    }
    
    try {
        const canSwitchToOnlineSync = getIsOfflineDataFaulted() &&
            !getIsDataWorkerFaulted() &&
            isGlobalFeatureEnabled("peo-no-hub-fallback");
        if (isOfflineSyncEnabled(mailboxInfo) && !canSwitchToOnlineSync) {
            return false;
        }
        
        const pdvStateDetails: PDVStateDetails = {};
        if (isOfflinePeopleDataViaPDVEnabled(mailboxInfo, pdvStateDetails) &&
            pdvStateDetails.isPdvInMemoryEnabled &&
            !pdvStateDetails.isOfflinePeopleDataViaPDVEnabledAllUp) {
            return true;
        }
    }
    catch { }
    return false;
}

/**
 * Returns true if online sync is possible for the given app.
 */
export function isOnlineSyncEnabledForApp(app: string): boolean {
    switch (app) {
        case "PeopleNew":
            return true;
        default:
            return false;
    }
}
